import '@/components/profileDropdown/styles/profile_button.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import classNames from 'classnames';

import useResponsive from '@/services/hocs/useResponsive';

import Button from '@/components/button/Button';
import ProfileAvatar from '@/components/profileDropdown/components/ProfileAvatar';

import type { ProfileButtonProps } from '@/components/profileDropdown/types';

const ProfileButton = ({ active, userData }: ProfileButtonProps) => {
	const { t } = useTranslation();
	const { isDesktop } = useResponsive();
	const { id, child_name, profile_name, player_type, settings } = userData || {};
	const { show_player_type_image } = settings || {};

	if (!id) {
		return null;
	}

	const getPlayerTypeClass = () => {
		if (!player_type || !show_player_type_image) return '';

		switch (player_type) {
			case 'day_goal_champion':
				return 'profile-button--player-type profile-button--day-goal-champion';
			case 'math_surfer':
				return 'profile-button--player-type profile-button--math-surfer';
			case 'traveller':
				return 'profile-button--player-type profile-button--world-traveller';
			case 'letter_pilot':
				return 'profile-button--player-type profile-button--letter-pilot';
			default:
				return '';
		}
	};

	return (
		<Button
			className={classNames('profile-button', getPlayerTypeClass())}
			type="primary"
			color="blue"
			active={active}
			testId="profile-button"
		>
			<div className="profile-button__wrapper">
				<ProfileAvatar />
				{isDesktop && (
					<>
						<div className="profile-button__content" data-private>
							<span className="profile-button__name">
								{profile_name || child_name || t('header.add_name')}
							</span>
						</div>
						<div className="icon icon-chevron-down" />
					</>
				)}
			</div>
		</Button>
	);
};

function mapStateToProps({ sharedReducer }: any) {
	return {
		userData: sharedReducer.userData,
	};
}

export default connect(mapStateToProps)(ProfileButton);
